import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import { Loading, Message } from 'element-ui'
import {Base64} from 'js-base64'
let token = '';

axios.defaults.baseURL = 'https://pay2.suyunkc.com';
// axios.defaults.baseURL = 'https://test01.suyunkc.com';
// axios.defaults.baseURL = 'http://hyzx.cn/index.php';
// axios.defaults.headers.common['token'] = token;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';//配置请求头
// axios.defaults.timeout = 5000

// http请求拦截器
function ajaxPost(url, params, callfunc, async) {
    let userToken = getToken() || ''
    let header = {'Content-Type': 'application/x-www-form-urlencoded', 'XX-Token': userToken};
    axios({
        method: 'POST',
        url: axios.defaults.baseURL + url,
        data: qs.stringify(params),
        withCredentials: async,
        headers: {
            header
        },
    })
        .then(function (result) {
            if (callfunc) {
                callfunc(result)
            }
        })
        .catch(function () {
        })
}

function postRequest(url, params, header, dataType, msg = '加载中',showLoading=true) {
    return new Promise((resolve, reject) => {
        let userToken = getToken() || '';
        axios({
            method: 'POST',
            url: axios.defaults.baseURL + url,
            data: qs.stringify(params),
            withCredentials: false,
            dataType: dataType || 'formData',
            headers: {
                'Accept': '*/*',
                'Content-Type': header || 'application/x-www-form-urlencoded',
                'XX-Token': userToken
            }
        })
            .then(res => {
                res = res.data;
                if (res.code==10001){
                    alert(res.msg);
                    localStorage.removeItem('XX-Token');
                    localStorage.removeItem('exp_time');
                    if (localStorage.getItem('login_type')==2) {
                        router.push({name: 'MerchantLogin'});

                    }
                    else {
                        router.push({name: 'Login'});
                    }
                }
                resolve(res);
            })
            .catch(res => {
                reject(res)
            })
    })
}
function fileRequest(url, params, header, dataType, msg = '加载中',showLoading=true) {
    return new Promise((resolve, reject) => {
        let userToken = getToken() || '';
        axios({
            method: 'POST',
            url: axios.defaults.baseURL + url,
            data: qs.stringify(params),
            withCredentials: false,
            dataType: dataType || 'formData',
            responseType:'blob',
            headers: {
                'Accept': '*/*',
                'Content-Type': header || 'application/x-www-form-urlencoded',
                'XX-Token': userToken
            }
        })
            .then(res => {
                res = res.data;
                if (res.code==10001){
                    alert(res.msg);
                    localStorage.removeItem('XX-Token');
                    localStorage.removeItem('exp_time');
                    if (localStorage.getItem('login_type')==2) {
                        router.push({name: 'MerchantLogin'});

                    }
                    else {
                        router.push({name: 'Login'});
                    }
                }
                resolve(res);
            })
            .catch(res => {
                reject(res)
            })
    })
}

// 文件流表单
function upLoaderImg(url, params) {
    let userToken = getToken() || ''
    let config = {
        headers: {
            //添加请求头
            'Content-Type': 'multipart/form-data',
            'XX-Token': userToken,
        },
    }
    return new Promise((resolve, reject) => {
        axios
            .post(axios.defaults.baseURL + url, params, config)
            .then(res => {
                if (res) {
                    //如果为真 resolve出去
                    resolve(res)
                } else {
                    //否则
                    reject(res)
                }
            })
            .catch(err => {
                reject(err)
            })
    })
}

function getToken() {
    return localStorage.getItem('XX-Token')
}

export default {
    upLoaderImg: upLoaderImg,
    postRequest: postRequest,
    fileRequest: fileRequest,
    postJson: function (url, params) {
        let call = arguments[2] || null
        let asyncAjax = arguments[3] || false
        ajaxPost(url, params, call, asyncAjax)
    },
}



// WEBPACK FOOTER //
// ./src/component/httpRequest.js